var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_STORE_IMAGE = 'api/store-image';
const GET_SET_STORES = 'api/store';
/** Saves the submitted settings to all active stores in the source store's company, including the source. */
export const copyLoyaltySettings = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`api/v2/stores/${storeId}/settings/loyalty/copy`, data, config);
        }
        catch (error) {
            console.error('Error copying loyalty settings:', error);
            throw error;
        }
    });
};
export const createStoreImage = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}`, 'Content-Type': false }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_STORE_IMAGE}`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching createStoreImage:', error);
            throw error;
        }
    });
};
export const createStore = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_STORES}`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching createStore:', error);
            throw error;
        }
    });
};
export const copyStore = function (copyStoreId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (!copyStoreId)
                throw new Error('store id required');
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_STORES}/copy`, {
                fromStoreId: copyStoreId
            }, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching createStore:', error);
            throw error;
        }
    });
};
